import { render, staticRenderFns } from "./MenuWhatsApp.vue?vue&type=template&id=0872bc21&scoped=true&"
import script from "./MenuWhatsApp.vue?vue&type=script&lang=js&"
export * from "./MenuWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./MenuWhatsApp.vue?vue&type=style&index=0&id=0872bc21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872bc21",
  null
  
)

export default component.exports